// extracted by mini-css-extract-plugin
export default {"redDot":"_169b09275ed2ef4d"};